import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateDirective } from '@foundation/translations/services';
import { UserTableComponent } from '@foundation/users/ui';

@Component({
	selector: 'lib-admin-users-page',
	standalone: true,
	imports: [TranslateDirective, UserTableComponent],
	templateUrl: './admin-users-page.component.html',
	styleUrl: './admin-users-page.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminUsersPageComponent {
	private _router = inject(Router);

	goToUserBuilder(userId: string) {
		this._router.navigate(['/admin/users', userId, 'builder']);
	}
}
